import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { hasVisiblePaymentSystems } from '@/checkout-instore-legacy/utils/PaymentUtils'
import { genericImportantError } from '@/checkout-instore-legacy/utils/EventHelper'

import NoPaymentsImage from '@/checkout-instore-legacy/components/Commons/NoPaymentsImage'

class NoPaymentsAvailableNotification extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { isVisible: false }
  }

  reportErrorToLogging() {
    const { giftCards, paymentSystems, payments } = this.props
    genericImportantError('no-payments-available', {
      context: 'sale',
      giftCards,
      paymentSystems,
      payments,
    })
  }

  componentDidUpdate() {
    if (this.state.isVisible) {
      this.reportErrorToLogging()
    }
  }

  componentDidMount() {
    if (this.state.isVisible) {
      this.reportErrorToLogging()
    }
  }

  static getDerivedStateFromProps(props) {
    const { giftCards, paymentSystems, payments } = props
    const isVisible = !hasVisiblePaymentSystems(
      paymentSystems,
      payments,
      giftCards
    )
    return { isVisible }
  }

  render() {
    const { isVisible } = this.state
    return (
      isVisible && (
        <div className="h-100 relative">
          <div className="flex aspect-ratio--object flex-column justify-center items-center pa4">
            <NoPaymentsImage />
            <h2 className="c-on-base ma0 mt7 tc">
              <FormattedMessage id="noPaymentsAvailableTitle" />
            </h2>
            <h3 className="normal c-muted-2 ma0 mt4 tc">
              <FormattedMessage id="noPaymentsAvailableSubtitle" />
            </h3>
          </div>
        </div>
      )
    )
  }
}

NoPaymentsAvailableNotification.propTypes = {
  giftCards: PropTypes.array,
  paymentSystems: PropTypes.array,
  payments: PropTypes.array,
}

export default NoPaymentsAvailableNotification
